import React from 'react'

const QuesLink = ({data, clickQuiz}) => {
  return (
    <span onClick={() => clickQuiz(data.quiz)} className="font-semibold text-blue-600 cursor-pointer hover:text-blue-700">{data.label}</span>
  )
}

export default QuesLink